import request from '@/utils/request'
import { v2Host } from '@/config/host'

export function getCountryList() {
  return request({
    url: `${v2Host}/common/country/list`,
    method: 'get'
  })
}
